import {ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import { FormObjectListComponent } from '../../../../shared/forms/form-object-list.component';
import { CorrectionEstimate } from '../../models/estimates/correction-estimate';
import { CorrectionEstimateComponent } from '../correction-estimate/correction-estimate.component';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'correction-estimate-list',
  templateUrl: './correction-estimate-list.component.html'
})
export class CorrectionEstimateListComponent extends FormObjectListComponent<CorrectionEstimateComponent, CorrectionEstimate> implements OnInit {
  @Input() form : UntypedFormGroup;
  @Input({ required: true }) componentGroupKey: number;
  @Input() isReadOnly: boolean = false;
  @ViewChildren(CorrectionEstimateComponent) override objectForms: QueryList<CorrectionEstimateComponent>;

  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef); // TODO: remove this once we decuple this from the parent class (not used here)
  }

  ngOnInit(): void {
    if (this.objectList.length === 0) { // check added here case it has values, will ensure its first paint of the app
      this.objectList.push(new CorrectionEstimate(""));
    }
  }

}
